// callback receives (directive, field, model) arguments and should return true if matched the directive to remove it

export default (typeDefs) => (callback) => {
    return {
        ...typeDefs,
        definitions: typeDefs.definitions?.map(def => {
            if (!def.fields || !def.fields.length) return def;
            return {
                ...def,
                fields: def.fields.map(f => {
                    if (!f.directives.length) return f;
                    return {
                        ...f,
                        directives: f.directives.filter(d => {
                            return !callback(d, f, def);
                        })
                    }
                })
            }
        })
    }
}
